export default function Calendar({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8 13V15H10V13H8Z" fill="currentColor" />
      <path d="M11 13H13V15H11V13Z" fill="currentColor" />
      <path d="M16 15V13H14V15H16Z" fill="currentColor" />
      <path d="M8 18V16H10V18H8Z" fill="currentColor" />
      <path d="M13 16H11V18H13V16Z" fill="currentColor" />
      <path d="M14 18V16H16V18H14Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6V7H15V6C15 5.44772 15.4477 5 16 5C16.5523 5 17 5.44772 17 6V7H19.5V21H4.5V7H7V6ZM5.5 11H18.5V20H5.5V11Z"
        fill="currentColor"
      />
    </svg>
  )
}
